import { Input } from 'almanac-ui/TextInputField/Input'
import { useEffect, useState } from 'react'
import { Text } from 'blaze-ui/Text/Text'
import { ChevronDown, Plus } from 'blaze-ui/icons'
import { ChevronRightSmall } from 'blaze-ui/icons/24'
import cx from 'classnames'
import Styles from './RepresentationPreferences.module.scss'

type Props = {
  details?: string
  onUpdate: (details: string) => void
  labelColor?: string
}

const TOGGLE_LABEL = 'Add Representation details (optional)'

const INSTRUCTION_COPY =
  'Describe cultural cues, style, or content to guide stock image and video selection only (where possible). This will not affect AI-generated content.'

const RepresentationDetails = ({ details, onUpdate, labelColor }: Props) => {
  const [stagedValue, setStagedValue] = useState(details ?? '')
  const [expanded, setExpanded] = useState(() => Boolean(details?.trim()))

  useEffect(() => {
    setStagedValue(details ?? '')
  }, [details])

  useEffect(() => {
    if (details?.trim()) {
      setExpanded(true)
    }
  }, [details])

  const toggleLabelColor = labelColor ?? 'var(--dark-90)'
  const iconColor = labelColor ?? 'var(--dark-90)'

  return (
    <div className={Styles.detailsRoot} data-testid="representation-details">
      <button
        type="button"
        className={cx(Styles.detailsToggle, expanded && Styles.detailsToggleExpanded)}
        onClick={() => setExpanded((open) => !open)}
        aria-expanded={expanded}
        aria-controls="representation-details-panel"
      >
        <span className={Styles.detailsToggleInner}>
          {expanded && (
            <span className={Styles.detailsToggleIcon} aria-hidden>
              <Plus size={15} color={iconColor} />
            </span>
          )}
          <Text variant="primary" color={toggleLabelColor}>
            {TOGGLE_LABEL}
          </Text>
          {expanded ? (
            <ChevronDown size={12} color={iconColor} aria-hidden />
          ) : (
            <ChevronRightSmall size={12} color={iconColor} aria-hidden />
          )}
        </span>
      </button>
      {expanded && (
        <div id="representation-details-panel" className={Styles.detailsPanel}>
          <Text variant="secondary" color="var(--dark-90)">
            {INSTRUCTION_COPY}
          </Text>
          <Input
            name="representation-details"
            isTextarea
            aria-label="Representation details"
            value={stagedValue}
            onChange={(e) => setStagedValue(e.target.value)}
            placeholder="Enter representation details"
            rows={3}
            size="lg"
            onBlur={() => onUpdate(stagedValue)}
          />
        </div>
      )}
    </div>
  )
}

export { RepresentationDetails }
